import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ResumoPedido } from 'src/app/models/resumoPedido';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { MultiFormaPagamentoModalComponent } from '../multi-forma-pagamento-modal/multi-forma-pagamento-modal.component';
import { Financa } from './../../models/financa';

// jquery
declare const $: any;

@Component({
  selector: 'app-resumo-financeiro-modal',
  templateUrl: './resumo-financeiro-modal.component.html',
  styleUrls: ['./resumo-financeiro-modal.component.scss']
})
export class ResumoFinanceiroModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  valorTotal = 0;
  idCupom = '';
  financas: Financa[] = [];

  resumo: ResumoPedido = new ResumoPedido();

  multiFormaPagamento = false;

  enumRecebimento = [
    { id: 0, name: 'Boleto Manual' },
    { id: 2, name: 'Boleto API' },
  ];

  enumFormaRecebimento = [
    { id: 1, name: 'Crédito' },
    { id: 2, name: 'Débito' },
    { id: 4, name: 'Boleto' },
    { id: 5, name: 'PIX' },
    { id: 6, name: 'Manual' },
  ];

  constructor(public dialogRef: MatDialogRef<ResumoFinanceiroModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private pedidoService: PedidoService, private utilitarioService: UtilitarioService,
    private carregandoService: CarregandoService, private notificacaoService: NotificacaoService, public dialog: MatDialog) { }

  ngOnInit() {
    this.buscarFinancas();
    this.buscarResumo();
  }

  buscarResumo() {
    this.carregandoService.mostra('buscarResumo');

    this.pedidoService.consultarResumo(this.data.idCupom).subscribe(
      (res) => {
        this.resumo = res;
        this.multiFormaPagamento = this.resumo.formasPagamento !== null && this.resumo.formasPagamento !== undefined && this.resumo.formasPagamento.length > 0;
        this.carregandoService.esconde('buscarResumo');
      },
      (erro) => {
        this.carregandoService.esconde('buscarResumo');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarFinancas() {
    this.carregandoService.mostra('buscarFinancas');

    this.valorTotal = this.data.valorTotal;
    this.idCupom = this.data.idCupom;

    this.pedidoService.consultarResumoFinanceiro(this.data.idCupom).subscribe(
      (res) => {
        this.financas = res;
        this.carregandoService.esconde('buscarFinancas');
      },
      (erro) => {
        this.carregandoService.esconde('buscarFinancas');
        this.notificacaoService.erro(erro);
      }
    );
  }

  abrirModalMultiFormasPagamento() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(MultiFormaPagamentoModalComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { formasPagamentoMulti: this.resumo.formasPagamento, valorPedido: 0, editavel: false, naoExibirTotais: true },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  getNameEnumRecebimento(id: number) {
    return this.enumRecebimento.find(x => x.id === id).name;
  }

  getNameEnumFormaRecebimento(id: number) {
    return this.enumFormaRecebimento.find(x => x.id === id).name;
  }

  fechar() {
    this.dialogRef.close();
  }

}
